import React from "react";
import CardList from "@/modules/CardList";
import { $t } from './i18n';

class Theme extends React.Component {
  render() {
    const { message = {}, className } = this.props
    return (
      <section id="theme" className={className}>
        {/* <h2 className="section-title">{$t(message.title)}</h2> */}
        <div className="theme-content">
          {/* <p className="theme-desc">{$t(message.desc)}</p> */}
          <CardList list={message.list} />
        </div>
      </section>
    );
  }
}

export default Theme;
